import { createContext, useContext, useState, useCallback } from 'react';
import { getCart, addToCart as apiAddToCart, removeFromCart as apiRemoveFromCart } from '@/lib/api';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState({ items: [], total_items: 0 });
  const [loaded, setLoaded] = useState(false);

  const refreshCart = useCallback(async () => {
    try {
      const res = await getCart();
      setCart(res.data);
      setLoaded(true);
    } catch {
      setCart({ items: [], total_items: 0 });
      setLoaded(true);
    }
  }, []);

  const addItem = async (collectibleId) => {
    await apiAddToCart(collectibleId);
    await refreshCart();
  };

  const removeItem = async (collectibleId) => {
    await apiRemoveFromCart(collectibleId);
    await refreshCart();
  };

  const isInCart = (collectibleId) => {
    return cart.items.some(i => i.collectible_id === collectibleId);
  };

  return (
    <CartContext.Provider value={{ cart, loaded, refreshCart, addItem, removeItem, isInCart }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be inside CartProvider');
  return ctx;
}
